import { isEmptyQuery } from '@modules/queryBuilder/helpers';
import { QueryBuilderActionType } from './queryBuilderActionType';
import { queryBuilderInitialState } from './queryBuilderInitialState';
import { QueryBuilderAction, QueryBuilderState } from './types';

export function queryBuilderReducer(
  state: QueryBuilderState,
  action: QueryBuilderAction,
): QueryBuilderState {
  const { type, payload } = action;
  switch (type) {
    case QueryBuilderActionType.INIT:
      return {
        ...state,
        ...payload,
      };
    case QueryBuilderActionType.INIT_QUERY: {
      const isEmpty = payload?.nodes
        ? isEmptyQuery(payload.nodes?.[payload.rootID ?? state.query.rootID])
        : state.metadata.isEmpty;

      return {
        ...state,
        query: {
          ...state.query,
          ...payload,
        },
        metadata: {
          ...state.metadata,
          isEmpty,
        },
      };
    }
    case QueryBuilderActionType.SET_QUERY: {
      const isEmpty = payload?.nodes
        ? isEmptyQuery(payload.nodes?.[payload.rootID ?? state.query.rootID])
        : state.metadata.isEmpty;

      return {
        ...state,
        query: {
          ...state.query,
          ...payload,
        },
        metadata: {
          ...state.metadata,
          hasUnsavedChanges: true,
          isEmpty,
          isActive: true,
        },
      };
    }
    case QueryBuilderActionType.RESET_QUERY: {
      return {
        ...state,
        ...queryBuilderInitialState,
      };
    }
    case QueryBuilderActionType.SET_METADATA: {
      return {
        ...state,
        metadata: {
          ...state.metadata,
          ...payload,
        },
      };
    }
    default:
      return state;
  }
}
